
export const isImgUrl = (url: string): boolean => {
  return /\.(jpg|jpeg|png|webp|avif|gif)$/.test(url)

}
